export const USERS = {
  key: 'users',
  path: '/',
};

export const PROFILE = {
  key: 'user-details',
  path: '/:userid',
};

export const POSTS = {
  key: 'posts',
  path: '/:userid/posts',
};

export const TAG = {
  key: 'tag',
  path: '/:tagname/tag',
};
